/**
 * Variant Input Form - Varyant verilerini girişi için form bileşeni
 */

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Paper,
  Grid,
  Box,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Science as ScienceIcon,
} from '@mui/icons-material';
import { formatPercentage } from '../../utils/statisticsUtils';
import { BRAND } from '../../theme/brandTheme';

const VariantInputForm = ({
  variants,
  onVariantChange,
  onAddVariant,
  onRemoveVariant,
  showSampleButton,
  onLoadSampleData,
  loading,
}) => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.purple }}>
            Test Verileri
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {showSampleButton && (
              <Button
                variant="contained"
                onClick={onLoadSampleData}
                disabled={loading}
                startIcon={<ScienceIcon />}
                size="small"
                sx={{
                  bgcolor: BRAND.green,
                  boxShadow: 'none',
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': { bgcolor: '#089a1f', boxShadow: 'none' },
                }}
              >
                Örnek Veriler
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={onAddVariant}
              startIcon={<AddIcon />}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              Varyant Ekle
            </Button>
          </Box>
        </Box>

        {showSampleButton && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              bgcolor: `${BRAND.purple}08`,
              border: `1px dashed ${BRAND.borderLight}`,
            }}
          >
            <Typography variant="body2" sx={{ color: BRAND.textMuted, mb: 1 }}>
              Henüz veri girilmedi. 3 varyantlı örnek bir e-ticaret testi ile aracı hemen deneyebilirsiniz.
            </Typography>
            <Typography variant="caption" sx={{ color: BRAND.textMuted }}>
              Control %5 · Variant A %6,5 (kazanan) · Variant B %5,2 · AOV 350₺
            </Typography>
          </Box>
        )}

        {variants.map((variant, index) => (
          <Paper key={index} sx={{ p: 2, mb: 2, border: `1px solid ${BRAND.borderLight}` }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Varyant Adı"
                  value={variant.name}
                  onChange={(e) => onVariantChange(index, 'name', e.target.value)}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Sessions"
                  type="number"
                  value={variant.sessions}
                  onChange={(e) => onVariantChange(index, 'sessions', e.target.value)}
                  inputProps={{ min: 1 }}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Conversions"
                  type="number"
                  value={variant.conversions}
                  onChange={(e) => onVariantChange(index, 'conversions', e.target.value)}
                  inputProps={{ min: 0 }}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                {variant.sessions && variant.conversions && (
                  <Typography variant="body2" color="text.secondary">
                    CR: {formatPercentage(variant.conversions / variant.sessions)}
                  </Typography>
                )}
                {variant.isControl && (
                  <Chip label="Control" size="small" color="primary" />
                )}
              </Grid>

              <Grid item xs={12} sm={1}>
                {!variant.isControl && variants.length > 2 && (
                  <Tooltip title="Varyantı Sil">
                    <IconButton
                      onClick={() => onRemoveVariant(index)}
                      size="small"
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Paper>
        ))}
      </CardContent>
    </Card>
  );
};

export default VariantInputForm;
